<template>
    <div>
        <svg width="340" height="200" v-if="scoreData && (scoreData.length > 1 || !scoreIndicator)">
            {{scoreData}}
        </svg>
        <div v-else style="padding: 15px;">
            <i>Sorry, there is insufficienct data for plotting.</i>
        </div>
    </div>
</template>

<script>
    var d3 = Object.assign({},  
        require("d3-selection"), 
        require("d3-axis"),  
        require("d3-scale"),  
        require("d3-shape"),  
        require("d3-array"),  
    ); 

    export default {
        props: {
            graphWidth: {
                type: Number
            },
            graphHeight: {
                type: Number
            },
            scoreData: {
                type: Array, 
            },
            scoreIndicator: {}, 
            colorPalette: {
                type: Object
            }
        },
        methods: {
            drawBarplot: function (scoreData, scoreIndicator) {
                /* eslint-disable no-unused-vars */

                if(!scoreData || scoreData.length < 1) return
                
                var svg = d3.select(this.$el).select("svg")
                svg.selectAll("*").remove();
                var margin = {
                        top: 20,
                        right: 30,
                        bottom: 40,
                        left: 45
                    };
                var width = this.graphWidth
                var height = this.graphHeight
                if(width == undefined) width = +svg.attr("width")
                if(height == undefined) height = +svg.attr("height")
                var categoryCounts = scoreData.reduce((accum, entry) => {
                    if(!accum[entry]) accum[entry] = 0
                    accum[entry]++
                    return accum
                }, {})
                var categoryPcts = Object.keys(categoryCounts).reduce((accum, categoryName) => {
                    accum[categoryName] = categoryCounts[categoryName] / scoreData.length
                    return accum
                }, {})
                var x = d3.scaleBand().domain(Object.keys(categoryPcts)).range([margin.left, width - margin.right]);
                var y = d3.scaleLinear()
                    .domain([0, d3.max(Object.values(categoryPcts))])
                    .range([height - margin.bottom, margin.top]);
                svg.append("g")
                    .attr("class", "axis axis--y")
                    .attr("transform", "translate(" + margin.left + ",0)")
                    .call(d3.axisLeft(y).ticks(null, "%"));
                svg.append("g")
                    .attr("class", "axis axis--x")
                    .attr("transform", "translate(0," + (height - margin.bottom) + ")")
                    .call(d3.axisBottom(x))
                    .append("text")
                    .attr("x", width/2)
                    .attr("y", 34)
                    .attr("fill", "#000")
                    .attr("text-anchor", "end")
                    .attr("font-weight", "bold")
                    .text("Score Distribution")
                    .style("text-anchor", "middle");
                
                //Underline user's response
                d3.selectAll('g.tick')
                    .filter(function(d){ return d == scoreIndicator})
                    .attr("text-decoration", "underline")

                var plotData = Object.keys(categoryPcts).map((categoryName) => {
                    return {name: categoryName, value: categoryPcts[categoryName]}
                })
                var colorPalette = this.colorPalette
                svg.selectAll(".bar")
                    .data(plotData)
                    .enter().append("rect")
                    .attr("class", "bar")
                    .attr("x", function(d) { return x(d.name); })
                    .attr("y", function(d) { return y(d.value); })
                    .attr("width", x.bandwidth())
                    .attr("height", function(d) { return height - margin.bottom - y(d.value); })
                    .attr("fill", function(d) {return (colorPalette[d.name] ? colorPalette[d.name] : "black")})
                /*.append("path")
                    .datum(density)
                    .attr("fill", "#4682b4")
                    .attr("stroke", "#225177")
                    .attr("stroke-width", 1.5)
                    .attr("stroke-linejoin", "round")
                    .attr("d", d3.area()
                        .x(function (d) {
                            return x(d[0]);
                        })
                        .y0(height-margin.bottom)
                        .y1(function (d) {
                            return y(d[1]);
                        }));*/
            }
        },
        watch: {
            scoreData: function(){
                this.drawBarplot(this.scoreData, this.scoreIndicator)
            },
            scoreIndicator: function(){
                this.drawBarplot(this.scoreData, this.scoreIndicator)
            },
        },
        mounted: function(){
            this.$nextTick(() => {
                this.drawBarplot(this.scoreData, this.scoreIndicator)
            })
        }
    }
</script>